import { render, staticRenderFns } from "./cadastrar.vue?vue&type=template&id=341212e7&scoped=true&"
import script from "./cadastrar.vue?vue&type=script&lang=js&"
export * from "./cadastrar.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar.vue?vue&type=style&index=0&id=341212e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341212e7",
  null
  
)

export default component.exports